<template>
	<v-footer v-if="!hidden" height="auto" color="primary">
		<v-row justify="center" no-gutters>
			<v-col cols="12" class="white--text text-center">
				<v-row justify="center" no-gutters>
					<v-col v-for="icon in icons" :key="icon" class="px-2 shrink">
						<v-btn class="white--text" icon>
							<v-icon>{{ icon }}</v-icon>
						</v-btn>
					</v-col>
				</v-row>
			</v-col>

			<v-col cols="12" class="pt-2 white--text text-center">
				<v-btn text dark class="text-none" @click="goHome">{{ home }}</v-btn>
				<v-btn text dark class="text-none">{{ about_us }}</v-btn>
				<v-btn id="contactUsButton" text dark class="text-none" @click="dialog = true">{{ contact_us }}</v-btn>
			</v-col>

			<v-col cols="12" class="pt-2 pb-2 text-center white--text" style="direction: ltr">
				<a href="/" style="text-decoration: none;" class="white--text">
					&copy;2019 —
					<strong>
						<span>Tele</span>
						<span class="font-weight-light">Retina</span>
					</strong>
				</a>
			</v-col>
		</v-row>

		<v-dialog v-model="dialog" max-width="500px" transition="dialog-transition">
			<v-card>
				<v-card-title primary-title>{{ contact_info }}</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-col cols="12" class="align-center">
						<a style="text-decoration: none" href="mailto:info@teleretina.care">
							<v-icon size="17" color="primary">mdi-email</v-icon>
							{{ email }}: info@teleretina.care
						</a>
						<br />
						<a style="text-decoration: none" href="mailto:admin@teleretina.care">
							<v-icon size="17" color="primary">mdi-email</v-icon>
							{{ email }}: admin@teleretina.care
						</a>
						<div class="pb-2"></div>
						<a
							style="text-decoration: none"
							href="https://www.google.com/maps/place/King+Fahad+Medical+City/@24.6859882,46.7063771,17z/data=!4m8!1m2!2m1!1sKing+Fahad+Medical+City+,+medical+school+,+sixth+flour+,+Riyadh+12372!3m4!1s0x3e2f0379f59d6c4b:0x8cf03683e3a39989!8m2!3d24.6859882!4d46.7041884"
							target="_blank"
							rel="noopener noreferrer"
						>
							<v-icon size="17" color="primary">mdi-map</v-icon>
							{{ address }}: {{ location }}
							<br />
							{{ location2 }}
						</a>
					</v-col>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-footer>
</template>

<script>
export default {
	data() {
		return {
			icons: [
				"mdi-facebook",
				"mdi-twitter",
				"mdi-youtube",
				"mdi-linkedin",
				"mdi-instagram"
			],
			home: "Home",
			about_us: "About Us",
			contact_us: "Contact Us",
			email: "Email",
			address: "Address",
			location: "Saudi Arabia, Riyadh",
			location2:
				"King Fahad Medical City, medical school, sixth flour, Riyadh 12372",
			contact_info: "Contact Information",
			dialog: false
		};
	},
	computed: {
		hidden() {
			return this.$store.state.isFooterHidden;
		},
		arabic() {
			return this.$store.state.arabic;
		}
	},
	watch: {
		arabic: {
			handler: function(newVal) {
				if (newVal) {
					this.$vuetify.rtl = true;
					this.headline = ".........";
					this.welcome = "اهلا بك في";
					this.tele = "تيلي";
					this.retina = "ريتنا";
					this.home = "الرئيسية";
					this.about_us = "عنا";
					this.contact_us = "تواصل معنا";
					this.email = "إيميل";
					this.address = "العنوان";
					this.location = "المملكة العربية السعودية, الرياض";
					this.location2 =
						"مدينة الملك فهد الطبية، كلية الطب ،الدور السادس، الرياض 12372";
					this.contact_info = "معلومات التواصل";
				} else {
					this.$vuetify.rtl = false;
					this.home = "Home";
					this.about_us = "About Us";
					this.contact_us = "Contact Us";
					this.email = "Email";
					this.address = "Address";
					this.location = "Saudi Arabia, Riyadh";
					this.location2 =
						"King Fahad Medical City, medical school, sixth flour, Riyadh 12372";
					this.contact_info = "Contact Information";
				}
			},
			immediate: true
		}
	},
	mounted() {
		if (this.arabic) {
			this.$vuetify.rtl = true;
			this.headline = ".........";
			this.welcome = "اهلا بك في";
			this.tele = "تيلي";
			this.retina = "ريتنا";
			this.home = "الرئيسية";
			this.about_us = "عنا";
			this.contact_us = "تواصل معنا";
			this.email = "إيميل";
			this.address = "العنوان";
			this.location = "المملكة العربية السعودية, الرياض";
			this.location2 =
				"مدينة الملك فهد الطبية، كلية الطب ،الدور السادس، الرياض 12372";
			this.contact_info = "معلومات التواصل";
		}
	},
	methods: {
		goHome() {
			this.$router.push("/");
		}
	}
};
</script>